import { render, staticRenderFns } from "./popupInfo.vue?vue&type=template&id=370508c9&scoped=true"
import script from "./popupInfo.vue?vue&type=script&lang=js"
export * from "./popupInfo.vue?vue&type=script&lang=js"
import style0 from "./popupInfo.vue?vue&type=style&index=0&id=370508c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370508c9",
  null
  
)

export default component.exports